import createSvgIcon from '@ixigo/icons/utils/createSvgIcon';
import { Fragment } from 'react';

export const ParkingFilled = createSvgIcon(
	<Fragment>
		<path
			d="M13.911 10.1652C13.911 10.5492 13.783 10.8764 13.527 11.1466C13.2567 11.4168 12.887 11.5448 12.4319 11.5448H10.7536V8.81414H12.4319C12.887 8.81414 13.2567 8.94214 13.527 9.19814C13.783 9.46836 13.911 9.79547 13.911 10.1652Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.55556 4C5.59188 4 4 5.59188 4 7.55556V16.4444C4 18.4081 5.59188 20 7.55556 20H16.4444C18.4081 20 20 18.4081 20 16.4444V7.55556C20 5.59188 18.4081 4 16.4444 4H7.55556ZM15.319 8.54391C15.0203 8.06036 14.6221 7.69058 14.0959 7.42036C13.5839 7.16436 13.0007 7.02214 12.375 7.02214H9.8763C9.32402 7.02214 8.8763 7.46985 8.8763 8.02213V16.0461C8.8763 16.5606 9.29337 16.9777 9.80786 16.9777C10.3223 16.9777 10.7394 16.5606 10.7394 16.0461V13.3226H12.375C13.0007 13.3226 13.5839 13.1946 14.0959 12.9386C14.6221 12.6684 15.0203 12.2986 15.319 11.815C15.6176 11.3315 15.7599 10.7768 15.7599 10.1652C15.7599 9.55369 15.6176 9.01325 15.319 8.54391Z"
			fill="currentColor"
		/>
	</Fragment>,
	'ParkingFilled',
);

export default ParkingFilled;
